import { render, staticRenderFns } from "./StatsCards.vue?vue&type=template&id=4f182c56&scoped=true&"
import script from "./StatsCards.vue?vue&type=script&lang=js&"
export * from "./StatsCards.vue?vue&type=script&lang=js&"
import style0 from "./StatsCards.vue?vue&type=style&index=0&id=4f182c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f182c56",
  null
  
)

export default component.exports